import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, tap } from 'rxjs';
import { UtilsTableService } from '../../services/utils-table.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Tab } from '../../models/utils-tabs';

@Component({
  selector: 'app-archive-filters',
  standalone: true,
  templateUrl: './archive-filters.component.html',
  imports: [MatFormField, MatIcon, MatInput, MatSuffix, MatTooltip, ReactiveFormsModule],
  styleUrl: './archive-filters.component.scss'
})
export class ArchiveFiltersComponent implements OnInit {
  @Input() tab: Tab | null = null;

  tooltipMessage = '';
  readonly searchCtrl = new FormControl('', { nonNullable: true });

  private readonly tooltipMessageForShipmentsAndContainers =
    'Min. number of characters: 3. Filtering by: References, SGL Shipment No., ' +
    'House No. (HBL/HAWB), Master No., Liner Booking No. and Container No.';
  private readonly tooltipMessageForOrdersAndExceptions = 'Min. number of characters: 3. Filtering by: Order Number.';
  private readonly tableService = inject(UtilsTableService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.tooltipMessage =
      this.tab?.type === 'Shipments' || this.tab?.type === 'Containers'
        ? this.tooltipMessageForShipmentsAndContainers
        : this.tooltipMessageForOrdersAndExceptions;
    this.searchCtrl.valueChanges
      .pipe(
        map(val => val.trim()),
        debounceTime(500),
        distinctUntilChanged(),
        filter(val => val.length === 0 || val.length > 2),
        tap(value => {
          if (this.tab !== null) {
            this.tableService.updatePageConfig(this.tab.id, {
              search: { columnKey: null, value }
            });
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
